export default "\n\n<nav></nav>\n<router-outlet></router-outlet>\n\n"